export default __webpack_public_path__ + "static/media/Laughing Auspices of the Celestial.ee8c6fbb.jpg";